import { useQuery } from "@tanstack/react-query";

import { productActions } from "@fitness-app/app-store";

import { useAppDispatch } from "~/store/initializeStore";

export const useProductDetails = (productId: string, enabled?: boolean) => {
  const dispatch = useAppDispatch();
  const { data: product } = useQuery({
    queryKey: ["product", productId],
    queryFn: () => dispatch(productActions.fetchProduct(productId)),
    enabled: !!productId && enabled,
    refetchOnWindowFocus: true,
    onSuccess: () => {
      dispatch(productActions.subscribeToProduct(productId));
    },
  });

  return product;
};
